import { render, staticRenderFns } from "./report-assignment-filters.vue?vue&type=template&id=5f52d6b2"
import script from "./report-assignment-filters.vue?vue&type=script&lang=js"
export * from "./report-assignment-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports